import React, { useEffect, useRef, useState } from "react";
// import { Input, toAbsoluteUrl } from 'sr/helpers'
import { toAbsoluteUrl } from "sr/helpers";
import { Link, useNavigate } from "react-router-dom";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPen } from '@fortawesome/free-solid-svg-icons';
import { useFormik } from "formik";
import { verifyOTP } from "sr/utils/api/verifyOTP";
import * as Yup from "yup";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getCompany } from "sr/utils/api/company/getCompany";
import { getIndividual } from "sr/utils/api/individual/getIndividual";
import { getSupervisor } from "sr/utils/api/company/workorder/getSupervisor";
import { getCleaner } from "sr/utils/api/cleaner/getCleaner";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
// import { ModelWrapperWithButton } from 'app/pages/company/component/ModelWrapperWithButton';
// import { useIntl } from 'react-intl';
// import { updateCompany } from 'sr/utils/api/company/updateCompany';
// import { updateIndividual } from 'sr/utils/api/individual/updateIndividual';
// import { updateSupervisor } from 'sr/utils/api/company/workorder/updateSupervisor';
// import { updateCleaner } from 'sr/utils/api/cleaner/updateCleaner';
import { sendOTP } from "sr/utils/api/sendOTP";
import { getCorporate } from "sr/utils/api/corporate/getCorporate";
export function VerifyOTP({
  type = "",
  channel = "email",
  otpsuccess = null,
  authRequired = false,
}) {
  const [registeredData, setRegisteredData] = useState(null);
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [userId, setUserId] = useState<string>();
  const [resendSeconds, setResendSeconds] = useState(type === "popup" ? 0 : 30);
  const [resendLoading, setResendLoading] = useState(false);
  // const [email, setEmail] = useState<string>()
  // const [showModel, setShowModel] = useState(false)
  // const [error, setError] = useState()
  useEffect(() => {
    const { user_id } = getUserDetails();
    setUserId(user_id);
  }, []);
  const fetchData = async () => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("id", userId);
      let res;
      if (localStorage.getItem("RegisterAs") === "Company") {
        res = await getCompany(queryParams);
      } else if (localStorage.getItem("RegisterAs") === "Individual") {
        res = await getIndividual(queryParams);
      } else if (localStorage.getItem("RegisterAs") === "supervisor") {
        res = await getSupervisor(queryParams);
      } else if (localStorage.getItem("RegisterAs") === "Corporate") {
        res = await getCorporate(userId);
      } else {
        res = await getCleaner(queryParams);
      }
      if (
        res?.success === true &&
        localStorage.getItem("RegisterAs") === "Corporate"
      ) {
        setRegisteredData(res?.data?.corporate);
        setLoader(false);
      } else if (res?.success === true) {
        setRegisteredData(res?.data);
        setLoader(false);
      } else {
        setLoader(false);
        alert(JSON.stringify(res));
      }
    } catch (e) {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (userId) {
      fetchData();
    }
  }, [userId]);
  useEffect(() => {
    if (channel !== "email") return;
    const timer = window.setInterval(() => {
      setResendSeconds((seconds) => Math.max(0, seconds - 1));
    }, 1000);
    return () => window.clearInterval(timer);
  }, [channel]);
  // const intl = useIntl()
  const inputRefs = useRef<Array<React.RefObject<HTMLInputElement>>>([]);
  if (inputRefs.current.length === 0) {
    inputRefs.current = Array.from({ length: otp.length }, () =>
      React.createRef<HTMLInputElement>(),
    );
  }

  const handleInputChange = (index: number, value: string) => {
    const newOtp = [...otp];
    newOtp[index] = value;

    setOtp(newOtp);
    if (value.length === 1 && index < otp.length - 1) {
      inputRefs.current[index + 1]?.current?.focus();
    }
  };

  const handleResendOTP = async () => {
    if (resendSeconds > 0 || resendLoading || !registeredData?.username) return;
    setResendLoading(true);
    try {
      const result = await sendOTP({
        username: registeredData.username,
        channel: "email",
      });
      if (result?.success === true) {
        setOtp(["", "", "", ""]);
        setResendSeconds(30);
        inputRefs.current[0]?.current?.focus();
      }
    } finally {
      setResendLoading(false);
    }
  };

  const initialValues = {
    username: registeredData?.username,
    otp: otp.join(""),
    channel: channel,
  };
  const { errors, submitForm } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      otp: Yup.string().required("Please Enter 4 Digit Verification Code"),
    }),
    onSubmit: async (values) => {
      try {
        setLoader(true);
        const result = await verifyOTP(values, { authRequired: true });
        setLoader(false);
        if (result.success === true) {
          if (otpsuccess) {
            otpsuccess();
          } else {
            if (localStorage.getItem("RegisterAs") === "Company") {
              navigate("/company-profile");
            } else if (localStorage.getItem("RegisterAs") === "Individual") {
              navigate("/individual/jobs");
            } else if (localStorage.getItem("RegisterAs") === "supervisor") {
              navigate("/supervisor/work-order");
            } else if (localStorage.getItem("RegisterAs") === "corporate") {
              navigate("/corporate/requirement-listing");
            } else {
              navigate("/cleaner-profile");
            }
          }
        } else {
          setLoader(false);
        }
      } catch (e) {
        setLoader(false);
      } finally {
        setLoader(false);
      }
    },
  });
  // const schema = Yup.object().shape({
  //   email: Yup.string()
  //     .trim()
  //     .lowercase()
  //     .required('INPUT.VALIDATION.EMAIL')
  //     .email('INPUT.VALIDATION.CUSTOMER.EMAIL.INVALID'),
  // });

  // const handleEmailChange = async ()=> {
  //     const payload = {
  //     id:registeredData?.id || registeredData?._id,
  //     email:email
  // }

  // setLoader(true)
  // try {

  //     await schema.validate({ email });

  // let res;
  // if(localStorage.getItem('RegisterAs') === 'Company') {
  //     res = await updateCompany(payload)
  // }
  // else if(localStorage.getItem('RegisterAs') === 'Individual') {
  //     res = await updateIndividual(payload)
  // }
  // else if(localStorage.getItem('RegisterAs')==='supervisor')
  // {
  //    res = await updateSupervisor(payload)
  // }
  // else {

  //     res = await updateCleaner(payload)

  // }
  // if(res?.success) {
  //     const otpresult = await sendOTP({username:registeredData?.username})
  //     if(otpresult?.success===true) {
  //         if(type !=='popup'){

  //         setShowModel(false)
  //             fetchData()
  //         }
  //         else {
  //                 if (otpsuccess) {
  //                     otpsuccess()
  //                 }
  //         }
  //     }
  // }
  // }
  // catch(e:any) {
  //     setLoader(false)

  //         if(e.name==='ValidationError'){
  //     setError(e.message)
  //         }
  // }
  // }
  // const onCheckModel = ()=> {
  //     setShowModel(false)
  // }
  useEffect(() => {
    if (type !== "popup") {
      if (registeredData?.isEmailVerified === true) {
        navigate("/cleaner-profile");
      }
    }
  }, [registeredData, channel, type]);
  // useEffect(()=>{
  // if(registeredData?.email){
  //     setEmail(registeredData?.email)
  // }
  // },[registeredData])
  return (
    <>
      <main>
        {loader && <LoaderFullScreen></LoaderFullScreen>}
        <div
          className={`lg:container mx-auto lg:max-w-3xl ${
            type !== "popup" ? "lg:mt-44" : "lg:mt-8"
          }  mt-8 px-4 lg:px-0`}
        >
          <div className="lg:flex-1 lg:flex block flex-col lg:mt-0 mt-4 h-fit lg:mx-12 mx-auto p-6 bg-white border border-gray-border rounded-xl">
            {type !== "popup" && (
              <div className="flex justify-center">
                <Link to="/" className="">
                  <img
                    width={150}
                    src={toAbsoluteUrl("/media/logos/logo2.png")}
                    alt=""
                    className="bg-white rounded-lg"
                  />
                </Link>
              </div>
            )}
            <h1 className="text-center text-xl mt-10">
              Verify {channel === "email" ? "email address" : "mobile number"}
            </h1>
            <div className="text-center">
              <form className="mt-5">
                <label className={`text-normal  text-sm`}>
                  Please enter the verification code sent to your{" "}
                  {channel === "email" ? "email address" : "mobile number"}:
                  <div className="mt-1">
                    <span className="font-semibold text-gray-900">
                      {channel === "email"
                        ? registeredData?.email
                        : registeredData?.mobile_number}
                    </span>
                    {/* {type !=='popup' &&
                                        <FontAwesomeIcon onClick={()=> setShowModel(true)} icon={faPen} className='ml-2 text-gray-800 cursor-pointer' />
                                      } */}
                  </div>
                </label>
                <div className="mt-5 flex justify-center">
                  {otp.map((digit, index) => (
                    <div className="w-16 mr-5" key={index}>
                      <input
                        type="tel"
                        maxLength={1}
                        className="mt-2  text-center text-sm block w-full md:px-4 sm:px-1 md:py-2 sm:py-1 sm:text-sm md:text-md text-gray-700 placeholder-gray-500 bg-white border border-gray-border rounded-2xl
                        focus:border-sky-200 focus:ring-sky-200 focus:outline-none focus:ring focus:ring-opacity-40"
                        value={digit}
                        onChange={(e) =>
                          handleInputChange(index, e.target.value)
                        }
                        ref={inputRefs.current[index]}
                      />
                    </div>
                  ))}
                </div>
              </form>
              {errors?.otp && (
                <p className="mt-3 text-red-400 md:text-sm sm:text-[.65rem]">
                  {errors?.otp}
                </p>
              )}
              {channel === "email" && (
                <div className="mt-4 text-sm" aria-live="polite">
                  {resendSeconds > 0 ? (
                    <span className="text-neutral-500">
                      Resend OTP in {resendSeconds}s
                    </span>
                  ) : (
                    <button
                      type="button"
                      className="font-bold text-[#0078ae] hover:underline disabled:cursor-not-allowed disabled:opacity-50"
                      disabled={resendLoading}
                      onClick={handleResendOTP}
                    >
                      {resendLoading ? "Resending..." : "Resend OTP"}
                    </button>
                  )}
                </div>
              )}
              <div className="mt-5 mb-2 flex space-x-10 justify-center">
                <button
                  type="submit"
                  className="rounded-full
                                bg-[#ff39b3] font-bold
                                p-2
                                text-white
                                w-44
                                cursor-pointer
                                hover:bg-navy"
                  onClick={submitForm}
                >
                  Verify
                </button>
                {/* {type !== "popup" && (
                  <button
                    type="submit"
                    className="rounded-full
                                bg-[#ff39b3] font-bold
                                p-2
                                text-white
                                w-44
                                cursor-pointer
                                hover:bg-navy"
                    onClick={() => {
                      localStorage.getItem("RegisterAs") === "Company"
                        ? navigate("/company-profile")
                        : localStorage.getItem("RegisterAs") === "Individual"
                        ? navigate("/individual/jobs")
                        : localStorage.getItem("RegisterAs") === "supervisor"
                        ? navigate("/supervisor/work-order")
                        : navigate("/cleaner-profile");
                    }}
                  >
                    Skip
                  </button>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* <ModelWrapperWithButton Save={handleEmailChange} showModal={showModel} onCheckModel ={onCheckModel}>
              <Input
                  onChange={(e)=> setEmail(e.target.value)}
                    label={intl.formatMessage({
                      id: "AUTH.INPUT.EMAIL.ADDRESS",
                      defaultMessage: "Email Address",
                    })}
                    placeholder={intl.formatMessage({
                      id: "AUTH.INPUT.EMAIL.PLACEHOLDER",
                      defaultMessage: "Enter your email id",
                    })}
                    type={"email"}
                    required={true}
                    name="email"
                    value={email}
                    error={error}
                  ></Input>
              </ModelWrapperWithButton> */}
    </>
  );
}
